const LAMBDA_URL = process.env.REACT_APP_BOOKS_LAMBDA_URL || "https://YOUR-LAMBDA-URL.execute-api.ap-southeast-2.amazonaws.com/prod/books";
const API_KEY = process.env.REACT_APP_BOOKS_API_KEY || "";
const TOKEN_KEY = "books_auth_token";

export function getStoredToken() {
    return localStorage.getItem(TOKEN_KEY);
}

function storeToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
}

export function clearStoredToken() {
    localStorage.removeItem(TOKEN_KEY);
}

async function post(body) {
    const response = await fetch(LAMBDA_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Api-Key": API_KEY,
        },
        body: JSON.stringify(body),
    });

    if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.message || "Request failed");
    }

    const data = await response.json();
    return Array.isArray(data) ? data[0] : data;
}

export async function fetchBookSeries(authType, credentials = {}) {
    const body = { authType };

    if (authType === "user") {
        body.username = credentials.username;
        body.password = credentials.password;
    }

    const result = await post(body);

    if (authType === "user" && result.token) {
        storeToken(result.token);
    }

    return result.bookSeries || [];
}

export async function fetchBookSeriesWithToken(token) {
    const result = await post({ authType: "token", token });
    return result.bookSeries || [];
}
